@switch (notify?.notify_channel) {
  @case (notifyService?.channels.bonuses) {
    <div (click)="navigateByRoute('/account')" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/bonuses.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold">{{ notify?.title }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.channels.freespins) {
    <div (click)="navigateByRoute('/account')" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/freespins.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold">{{ notify?.title }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.channels.lootboxes) {
    <div (click)="navigateByRoute(notify.link)" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/lootboxes.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold">{{ notify?.title }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.channels.payments) {
    <div (click)="navigateByRoute('/account/balance')" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/payments.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold">{{ notify?.title }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.channels.limits) {
    <div (click)="navigateByRoute('/')" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/limits.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold">{{ notify?.title }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.channels.groups) {
    <div (click)="navigateByRoute('/loyalty')" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/groups.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold">{{ notify?.title }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.channels.tournaments) {
    <div (click)="navigateByRoute(notify.link)" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/tournaments.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold" [innerHTML]="notify?.title"></div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.channels.tournamentsStarted) {
    <div (click)="navigateByRoute(notify.link)" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/tournaments.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold" [innerHTML]="notify?.title"></div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.customChannels.VIP) {
    <div (click)="navigateByRoute(notify.link)" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/tournaments.svg'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold" [innerHTML]="notify?.title"></div>
        <div class="notify-item__text--smaller">{{ 't.vip-notification-desc' | translate }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.customChannels.INSTALL_APP) {
    <div (click)="navigateByRoute(notify.link)" class="notify-item">
      <div class="notify-item__left">
        <img class="notify-item__img" [attr.data-src]="'/assets/img/mobile-app/icon.png'" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold" [innerHTML]="notify?.title"></div>
        <div class="notify-item__text--smaller">{{ 'link.install-app' | translate }}</div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.customChannels.WELCOME_BONUSES) {
    <div (click)="navigateByRoute(notify.link)" class="notify-item devbit4849-welcome">
      <div class="notify-item__left">
        <img class="notify-item__img" [src]="notify?.Image" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold" [innerHTML]="notify?.Title"></div>
        <div class="notify-item__text--smaller" [innerHTML]="notify?.DescriptionStarterBonus | safe: 'html'"></div>
        <div class="notify-item__text--smaller"
             [innerHTML]="notify?.SecondDescriptionStarterBonus ? ('<span>+</span> ' + notify?.SecondDescriptionStarterBonus | safe:'html') : ''"></div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.customChannels.RELOAD_BONUSES) {
    <div (click)="navigateByRoute(['account', 'deposit'], {bonusCode: notify.bonusCode})" class="notify-item devbit4849-reload">
      <div class="notify-item__left">
        <img class="notify-item__img" [src]="notify.image" alt="">
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold" [innerHTML]="notify?.title | safe: 'html' "></div>
        <div class="notify-item__text--smaller" [innerHTML]="notify?.description | safe: 'html'"></div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
  @case (notifyService?.customChannels.UNUSED_BONUSES) {
    <div (click)="navigateByRoute('/account')" class="notify-item">
      <div class="notify-item__left">
        @switch (true) {
          @case (notify?.type === 'free_spins') {
            @if (customFlow?.customFlowData$ | async; as customFlowData) {
              @if (customFlowData?.game$ | async; as game) {
                <img class="notify-item__img notify-item__img--game"
                     [attr.data-src]="game?.imgSrc || notify?.games[0]?.imgSrc">
              }
            } @else {
              @if (notify?.games?.length) {
                <img class="notify-item__img notify-item__img--game" [attr.data-src]="notify?.games[0]?.imgSrc"
                     [alt]="notify?.games[0]?.name">
              }
            }
          }
          @default {
            <img class="notify-item__img" [attr.data-src]="'/assets/svg/notify/bonuses.svg'" alt="">
          }
        }
        <i (click)="notifyService.removeNotify(notify)" class="icon-trash"></i>
      </div>
      <div class="notify-item__center">
        <div class="notify-item__text--bold">{{ notify?.title }}</div>
        <div class="notify-item__text--smaller">{{ 't.grab-unused-bonuses' | translate }}</div>
        <div class="notify-item__text--expired">
          <img [attr.data-src]="'/assets/svg/notify/attention.svg'" alt="">
          {{ 't.expired-soon' | translate }}
        </div>
      </div>
      <i class="icon-arrow"></i>
    </div>
  }
}
